// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".headline[data-v-4338f936]{margin-left:.5rem;margin-right:.5rem;padding-top:1rem;padding-bottom:1rem;position:relative;text-align:left}@media (min-width:768px){.headline[data-v-4338f936]{margin-left:3rem}}.headline-span[data-v-4338f936]{--tw-text-opacity:1;color:rgba(0,0,0,var(--tw-text-opacity))}.headline-level-2[data-v-4338f936]{font-size:1.35rem}", ""]);
// Exports
module.exports = exports;
